import get from "lodash/get.js";

export const META_STATUS = {
	LOADING:     "loading",
	FAILED:      "failed", // permanent fail (e.g. content is too large)
	FAILED_TEMP: "failed-temp", // temporary fail (e.g. a 500 http response)
	READY:       "ready",
	UNAVAILABLE: "unavailable",
	DELETED:     "deleted"
};

export const ACTIONS = {
	CREATING: "creating",
	DELETING: "deleting",
	UPDATING: "updating"
};

/**
 * Individual comments
 **/
// @ts-expect-error TS(7006) FIXME: Parameter 'comment' implicitly has an 'any' type.
const getComment = (comment) => {
	const id = get(comment, "id", null);
	const status = get(comment, "status", null);
	const authorName = get(comment, "user.name", null);
	const content = get(comment, "content", "");
	const createdDt = get(comment, "created_dt", "");
	const editedDt = get(comment, "edited_dt", "");
	const customData = get(comment, "custom_data", {});

	return {id, authorName, content, createdDt, status, editedDt, customData};
};

// @ts-expect-error TS(7006) FIXME: Parameter 'metaData' implicitly has an 'any' type.
const getMetaData = (metaData) => {
	const action = get(metaData, "action", null);
	const editing = get(metaData, "editing", false);
	const metaStatus = get(metaData, "meta_status", "loading");
	const editedContent = get(metaData, "edited_content", "");
	const errorMessage = metaStatus === META_STATUS.FAILED || metaStatus === META_STATUS.FAILED_TEMP
		? get(metaData, "error_message", null)
		: null;

	return {action, metaStatus, editing, editedContent, errorMessage};
};

// @ts-expect-error TS(7006) FIXME: Parameter 'metaData' implicitly has an 'any' type.
const getHeading = (metaData) => {
	const {action, errorMessage, metaStatus} = getMetaData(metaData);

	if (metaStatus === META_STATUS.LOADING) {
		if (action === ACTIONS.CREATING)
			return "Sending...";
		else if (action === ACTIONS.DELETING)
			return "Deleting...";
		else if (action === ACTIONS.UPDATING)
			return "Updating...";
	} else if (metaStatus === META_STATUS.FAILED || metaStatus === META_STATUS.FAILED_TEMP)
		return errorMessage || "Error :(";

	return "";
};

// @ts-expect-error TS(7006) FIXME: Parameter 'comment' implicitly has an 'any' type.
const getCommentContent = (comment, metaData) => {
	const {content, status, editedDt} = getComment(comment);
	const {metaStatus, action, editedContent} = getMetaData(metaData);

	const isDeleted = [
		"deleted-by-admin",
		"deleted-by-user",
		"deleted-for-privacy"
	].includes(status);

	let contentBody = content;

	if ((metaStatus === META_STATUS.FAILED || metaStatus === META_STATUS.FAILED_TEMP) && action === ACTIONS.UPDATING)
		contentBody = editedContent;

	if (isDeleted)
		contentBody = "<i>This comment was deleted</i>";
	else if (editedDt) {
		const regexp = /([\s\S]*)(<\/p>)$/i;
		if (contentBody.match(regexp)) {
			// Add the edited indicator in the last tag if it's a paragraph
			contentBody = contentBody.replace(regexp, "$1 <i>(edited)</i>$2");
		} else
			contentBody = `${contentBody} <i>(edited)</i>`;
	}

	return contentBody;
};

// @ts-expect-error TS(7006) FIXME: Parameter 'isCommentOwner' implicitly has an 'any'... Remove this comment to see the full error message
const isCommentEditAllowed = (isCommentOwner, metaStatus, status) => {
	return isCommentOwner && metaStatus === META_STATUS.READY && status === "active";
};

// @ts-expect-error TS(7006) FIXME: Parameter 'metaStatus' implicitly has an 'any' typ... Remove this comment to see the full error message
const getToggleButtonText = (metaStatus, commentCount, visible) => {
	switch (metaStatus) {
		case META_STATUS.READY:
			if (commentCount === 0)
				return "Add Comment";

			return `${visible ? "hide" : "show"} ${commentCount} ${commentCount !== 1
				? "comments"
				: "comment"}`;
		case META_STATUS.LOADING:
			return "Loading comments...";
		case META_STATUS.FAILED: // fall-through
		case META_STATUS.FAILED_TEMP:
			return "Oops! Something went wrong.";
		default:
			return null;
	}
};

export default {
	getComment,
	getMetaData,
	getHeading,
	getCommentContent,
	getToggleButtonText,
	isCommentEditAllowed
};
